import React, { MouseEventHandler, useEffect, useState } from "react";
import chiudi from "../../assets/icons/azioni/mini/chiudi.svg";
import esegui from "../../assets/icons/azioni/mini/esegui-mini.svg";
import info from "../../assets/icons/form/info_tooltip.svg";
import help from "../../assets/icons/help/help_home.svg";

import "./style.scss";

interface TooltipProps {
    text: string;
    icon?: "help" | "info" | "chiudi" | "esegui";
    height?: string;
    width?: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean
}

let nextId = 0;

const CustomTooltip = (props: TooltipProps) => {
    const { text, icon = "info", height = "44px", width = "44px", onClick, disabled } = props;

    const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

    //Generazione id unico per tooltip
    const useUniqueId = () => {
        const [currentId, setCurrentId] = useState<string | undefined>(undefined);
        useEffect(() => {
            if (!currentId) {
                nextId++;
                setCurrentId('tooltip_' + nextId);
            }
        }, []);
        return currentId;
    };

    const tooltipId = useUniqueId();

    return (
        <>
            <div className="tooltip-help-home">
                <button
                    className="icon"
                    style={{ height: height, width: width }}
                    role="button"
                    aria-labelledby={tooltipId ? tooltipId : 'tooltip_id'}
                    aria-haspopup="true"
                    aria-expanded={isTooltipVisible}
                    onFocus={() => setIsTooltipVisible(true)}
                    onBlur={() => setIsTooltipVisible(false)}
                    onMouseEnter={() => setIsTooltipVisible(true)}
                    onMouseLeave={() => setIsTooltipVisible(false)}
                    onKeyDown={(e) => {
                        e.key === "Escape" && setIsTooltipVisible(false)
                    }}
                    onClick={onClick}
                    disabled={disabled}
                >
                    <img style={{ height: height, width: width }}
                        src={icon === 'info' ? info : icon === "chiudi" ? chiudi : icon === "esegui" ? esegui : help} alt="" className="img-tooltip" />
                </button>

                <div
                    id={tooltipId ? tooltipId : 'tooltip_id'}
                    role="tooltip"
                    aria-hidden={!isTooltipVisible}
                    className={`tooltip-custom ${isTooltipVisible ? "visible" : ""}`}
                    aria-live="polite"
                    aria-atomic="true"
                    tabIndex={-1}
                >
                    {text}
                </div>
            </div>
        </>
    );
};

export default CustomTooltip;